import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { app } from './config';

const auth = getAuth(app);

const ALLOWED_EMAILS = [
  'rajeshmaydev@gmail.com',
  'indira02032001@gmail.com',
];

export const signIn = async (email, password) => {
  const credential = await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
  if (!ALLOWED_EMAILS.includes(credential.user.email)) {
    await signOut(auth);
    throw new Error('not-allowed');
  }
  return credential;
};

export const signOutUser = () => signOut(auth);

export const onAuthChange = (callback) => onAuthStateChanged(auth, callback);

export { auth };
